import React from "react";
import { MessageSquareWarning } from "lucide-react";

const Tooltip = ({ text }) => {
  return (
    <div className="relative group">
      {/* Glowing Warning Icon with Pulse Animation */}
      <MessageSquareWarning
        size={20}
        className="text-white cursor-pointer hover:text-[#178A94] 
                   transition-colors animate-pulse 
                   group-hover:animate-none drop-shadow-[0_0_10px_rgba(255,165,0,0.7)]"
      />
      
      {/* Tooltip Content */}
      <div className="absolute right-0 top-full mt-1 w-[clamp(12rem,25vw,16rem)] 
                      p-2 bg-[#2C2F30] text-[#EAECEF] text-[clamp(0.75rem,1.5vw,0.875rem)] 
                      rounded-lg shadow-xl border border-[#3A3D3E]
                      opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out
                      pointer-events-none z-[500000]">
        <span className="font-bold text-[#178A94]">Best Practices:</span>
        <ul className="list-disc pl-4 mt-1 space-y-1 text-[#EAECEF] text-sm">
          {text.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
        {/* Tooltip Arrow */}
        <div className="absolute right-2 top-[-4px] w-2 h-2 bg-[#2C2F30] 
                        border-l border-b border-[#3A3D3E] transform rotate-45">
        </div>
      </div>
    </div>
  );
};

export default Tooltip;
